import {buildGroupedLabel} from '../../Form/Select/Label';

export const selectedOption = (select) => {
    let selected = select.selectedOptions[0];

    if (!selected || !selected.value) {
        selected = select.querySelector('option[selected]') ?? selected;
    }

    return selected ?? null;
};

export const hasGroupAttributes = (option) => option?.dataset.name !== undefined;

export const buildOptionChip = (select, option) => {
    const chip = document.createElement('span');
    chip.className = 'field-value-tag';

    const iconClass = option.dataset.icon ?? select.closest('od-select')?.getAttribute('icon');

    if (iconClass) {
        const icon = document.createElement('i');
        icon.className = iconClass;
        chip.append(icon);
    }

    chip.append(
        option.dataset.group ? buildGroupedLabel(option) : document.createTextNode(option.text || option.value),
    );

    return chip;
};

export const buildTagChip = (option) => {
    const chip = document.createElement('span');

    chip.className   = `store-tag store-tag--${option.dataset.tagColor}`;
    chip.textContent = option.text || option.value;

    return chip;
};
